export const CountryOptions = [
   { value: "AF", label: "Afghanistan" },
   { value: "AL", label: "Albania" },
   { value: "DZ", label: "Algeria" },
   { value: "AS", label: "American Samoa" },
   { value: "AD", label: "Andorra" },
   { value: "AO", label: "Angola" },
   { value: "AI", label: "Anguilla" },
   { value: "AQ", label: "Antarctica" },
   { value: "AG", label: "Antigua and Barbuda" },
   { value: "AR", label: "Argentina" },
   { value: "AM", label: "Armenia" },
   { value: "AU", label: "Australia" },
   { value: "AT", label: "Austria" },
   { value: "AZ", label: "Azerbaijan" },
   { value: "BS", label: "Bahamas" },
   { value: "BH", label: "Bahrain" },
   { value: "BD", label: "Bangladesh" },
   { value: "BB", label: "Barbados" },
   { value: "BY", label: "Belarus" },
   { value: "BE", label: "Belgium" },
   { value: "BZ", label: "Belize" },
   { value: "BJ", label: "Benin" },
   { value: "BM", label: "Bermuda" },
   { value: "BT", label: "Bhutan" },
   { value: "BO", label: "Bolivia" },
   { value: "BA", label: "Bosnia and Herzegovina" },
   { value: "BW", label: "Botswana" },
   { value: "BR", label: "Brazil" },
   { value: "BN", label: "Brunei" },
   { value: "BG", label: "Bulgaria" },
   { value: "BF", label: "Burkina Faso" },
   { value: "BI", label: "Burundi" },
   { value: "CV", label: "Cabo Verde" },
   { value: "KH", label: "Cambodia" },
   { value: "CM", label: "Cameroon" },
   { value: "CA", label: "Canada" },
   { value: "KY", label: "Cayman Islands" },
   { value: "CF", label: "Central African Republic" },
   { value: "TD", label: "Chad" },
   { value: "CL", label: "Chile" },
   { value: "CN", label: "China" },
   { value: "CO", label: "Colombia" },
   { value: "KM", label: "Comoros" },
   { value: "CG", label: "Congo" },
   { value: "CD", label: "Congo (DRC)" },
   { value: "CR", label: "Costa Rica" },
   { value: "HR", label: "Croatia" },
   { value: "CU", label: "Cuba" },
   { value: "CY", label: "Cyprus" },
   { value: "CZ", label: "Czech Republic" },
   { value: "DK", label: "Denmark" },
   { value: "DJ", label: "Djibouti" },
   { value: "DM", label: "Dominica" },
   { value: "DO", label: "Dominican Republic" },
   { value: "EC", label: "Ecuador" },
   { value: "EG", label: "Egypt" },
   { value: "SV", label: "El Salvador" },
   { value: "GQ", label: "Equatorial Guinea" },
   { value: "ER", label: "Eritrea" },
   { value: "EE", label: "Estonia" },
   { value: "SZ", label: "Eswatini" },
   { value: "ET", label: "Ethiopia" },
   { value: "FJ", label: "Fiji" },
   { value: "FI", label: "Finland" },
   { value: "FR", label: "France" },
   { value: "GA", label: "Gabon" },
   { value: "GM", label: "Gambia" },
   { value: "GE", label: "Georgia" },
   { value: "DE", label: "Germany" },
   { value: "GH", label: "Ghana" },
   { value: "GR", label: "Greece" },
   { value: "GD", label: "Grenada" },
   { value: "GU", label: "Guam" },
   { value: "GT", label: "Guatemala" },
   { value: "GN", label: "Guinea" },
   { value: "GW", label: "Guinea-Bissau" },
   { value: "GY", label: "Guyana" },
   { value: "HT", label: "Haiti" },
   { value: "HN", label: "Honduras" },
   { value: "HU", label: "Hungary" },
   { value: "IS", label: "Iceland" },
   { value: "IN", label: "India" },
   { value: "ID", label: "Indonesia" },
   { value: "IR", label: "Iran" },
   { value: "IQ", label: "Iraq" },
   { value: "IE", label: "Ireland" },
   { value: "IL", label: "Israel" },
   { value: "IT", label: "Italy" },
   { value: "JM", label: "Jamaica" },
   { value: "JP", label: "Japan" },
   { value: "JO", label: "Jordan" },
   { value: "KZ", label: "Kazakhstan" },
   { value: "KE", label: "Kenya" },
   { value: "KI", label: "Kiribati" },
   { value: "KP", label: "Korea (North)" },
   { value: "KR", label: "Korea (South)" },
   { value: "KW", label: "Kuwait" },
   { value: "KG", label: "Kyrgyzstan" },
   { value: "LA", label: "Laos" },
   { value: "LV", label: "Latvia" },
   { value: "LB", label: "Lebanon" },
   { value: "LS", label: "Lesotho" },
   { value: "LR", label: "Liberia" },
   { value: "LY", label: "Libya" },
   { value: "LI", label: "Liechtenstein" },
   { value: "LT", label: "Lithuania" },
   { value: "LU", label: "Luxembourg" },
   { value: "MG", label: "Madagascar" },
   { value: "MW", label: "Malawi" },
   { value: "MY", label: "Malaysia" },
   { value: "MV", label: "Maldives" },
   { value: "ML", label: "Mali" },
   { value: "MT", label: "Malta" },
   { value: "MH", label: "Marshall Islands" },
   { value: "MR", label: "Mauritania" },
   { value: "MU", label: "Mauritius" },
   { value: "MX", label: "Mexico" },
   { value: "FM", label: "Micronesia" },
   { value: "MD", label: "Moldova" },
   { value: "MC", label: "Monaco" },
   { value: "MN", label: "Mongolia" },
   { value: "ME", label: "Montenegro" },
   { value: "MA", label: "Morocco" },
   { value: "MZ", label: "Mozambique" },
   { value: "MM", label: "Myanmar" },
   { value: "NA", label: "Namibia" },
   { value: "NR", label: "Nauru" },
   { value: "NP", label: "Nepal" },
   { value: "NL", label: "Netherlands" },
   { value: "NZ", label: "New Zealand" },
   { value: "NI", label: "Nicaragua" },
   { value: "NE", label: "Niger" },
   { value: "NG", label: "Nigeria" },
   { value: "NO", label: "Norway" },
   { value: "OM", label: "Oman" },
   { value: "PK", label: "Pakistan" },
   { value: "PW", label: "Palau" },
   { value: "PA", label: "Panama" },
   { value: "PG", label: "Papua New Guinea" },
   { value: "PY", label: "Paraguay" },
   { value: "PE", label: "Peru" },
   { value: "PH", label: "Philippines" },
   { value: "PL", label: "Poland" },
   { value: "PT", label: "Portugal" },
   { value: "QA", label: "Qatar" },
   { value: "RO", label: "Romania" },
   { value: "RU", label: "Russia" },
   { value: "RW", label: "Rwanda" },
   { value: "WS", label: "Samoa" },
   { value: "SM", label: "San Marino" },
   { value: "SA", label: "Saudi Arabia" },
   { value: "SN", label: "Senegal" },
   { value: "RS", label: "Serbia" },
   { value: "SC", label: "Seychelles" },
   { value: "SL", label: "Sierra Leone" },
   { value: "SG", label: "Singapore" },
   { value: "SK", label: "Slovakia" },
   { value: "SI", label: "Slovenia" },
   { value: "SB", label: "Solomon Islands" },
   { value: "SO", label: "Somalia" },
   { value: "ZA", label: "South Africa" },
   { value: "SS", label: "South Sudan" },
   { value: "ES", label: "Spain" },
   { value: "LK", label: "Sri Lanka" },
   { value: "SD", label: "Sudan" },
   { value: "SR", label: "Suriname" },
   { value: "SE", label: "Sweden" },
   { value: "CH", label: "Switzerland" },
   { value: "SY", label: "Syria" },
   { value: "TW", label: "Taiwan" },
   { value: "TJ", label: "Tajikistan" },
   { value: "TZ", label: "Tanzania" },
   { value: "TH", label: "Thailand" },
   { value: "TL", label: "Timor-Leste" },
   { value: "TG", label: "Togo" },
   { value: "TO", label: "Tonga" },
   { value: "TT", label: "Trinidad and Tobago" },
   { value: "TN", label: "Tunisia" },
   { value: "TR", label: "Turkey" },
   { value: "TM", label: "Turkmenistan" },
   { value: "TV", label: "Tuvalu" },
   { value: "UG", label: "Uganda" },
   { value: "UA", label: "Ukraine" },
   { value: "AE", label: "United Arab Emirates" },
   { value: "GB", label: "United Kingdom" },
   { value: "US", label: "United States" },
   { value: "UY", label: "Uruguay" },
   { value: "UZ", label: "Uzbekistan" },
   { value: "VU", label: "Vanuatu" },
   { value: "VE", label: "Venezuela" },
   { value: "VN", label: "Vietnam" },
   { value: "YE", label: "Yemen" },
   { value: "ZM", label: "Zambia" },
   { value: "ZW", label: "Zimbabwe" },
];
